import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { AlarmTypeParams } from './service';

export enum AlarmTypeActions {
  Failure = '[Catalogs AlarmType] Failure',
  Request = '[Catalogs AlarmType] Request',
  Success = '[Catalogs AlarmType] Success',
}

export const AlarmTypeFailure = createAction(AlarmTypeActions.Failure, props<{ error: HttpErrorResponse }>());

export const AlarmTypeRequest = createAction(AlarmTypeActions.Request, props<{ parameters: AlarmTypeParams }>());

export const AlarmTypeSuccess = createAction(AlarmTypeActions.Success, props<{ data: ParameterResult }>());
